import React, { useContext, useEffect, useState, useRef } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import StarRatings from "react-star-ratings";
import axios from "../../axios";
import { API_KEY, baseUrl, imageUrl, imageUrl2 } from "../../Constants/Constance";
import CryptoJS from "crypto-js";

import Navbar from "../../components/Header/Navbar";
import Footer from "../../components/Footer/Footer";
// import useUpdateMylist from "../CustomHooks/useUpdateMylist";
// import useUpdateLikedMovies from "../CustomHooks/useUpdateLikedMovies";
import { motion, AnimatePresence } from "framer-motion";

import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import usePlayMovie from "../../CustomHooks/usePlayMovie";

import axiosClient from "../../axios-client";
import usePlayVideo from "../../CustomHooks/usePlayVideo";
import { AuthContext } from "../../Context/UserContext";
import usePlaySerie from "../../CustomHooks/usePlaySerie";
import ContentPopup from "../../components/Popup/ContentPopup";
import SeriePopup from "../../components/Popup/SeriePopup";
import { decryptId } from "../../utils/encryption";
// import useUpdateWatchedMovies from "../CustomHooks/useUpdateWatchedMovies";

function Play() {
  const [urlId, setUrlId] = useState("");
  const [movieDetails, setMovieDetails] = useState();
  const [isFromMyList, setIsFromMyList] = useState(false);
  const [isFromLikedMovies, setIsFromLikedMovies] = useState(false);
  const [isFromWatchedMovies, setIsFromWatchedMovies] = useState(false);
  const [moreTrailerVideos, setMoreTrailerVideos] = useState([]);
  const [similarMovies, setSimilarMovies] = useState([]);
  const { playVideo } = usePlayVideo();
  const { playSerie } = usePlaySerie();

  const { user, profileId, userCountryCode } = useContext(AuthContext);

  const [showModal, setShowModal] = useState(false);
  const [moviePopupInfo, setMoviePopupInfo] = useState({});
  const [shouldPop, setshouldPop] = useState(true);
  const [isHovered, setIsHovered] = useState(false);

  const [isHoveredCard, setIsHoveredCard] = useState(false);
  const [hoveredCardIndex, setHoveredCardIndex] = useState(null);
  // const { addToMyList, removeFromMyList, PopupMessage } = useUpdateMylist();
  // const { addToLikedMovies, removeFromLikedMovies, LikedMoviePopupMessage } =useUpdateLikedMovies();
  // const { removeFromWatchedMovies, removePopupMessage } =useUpdateWatchedMovies();
  const { playMovie } = usePlayMovie();
  // const secretKeyEnv = process.env.REACT_APP_SECRET_KEY;

  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  // const decryptId = (encryptedId) => {
  //   try {
  //     const key = secretKeyEnv;
  //     const decoded = atob(encryptedId);
  //     const decryptedBytes = CryptoJS.AES.decrypt(decoded, key);
  //     return decryptedBytes.toString(CryptoJS.enc.Utf8);
  //   } catch (error) {
  //     // console.error("Error decrypting token:", error);
  //     return null;
  //   }
  // };
  const handleFavoriteClick = async (content, title) => {
    if (!userCountryCode) {
      // alert("Error: Impossible de déterminer votre emplacement.");
      toast.error(`Impossible de déterminer votre emplacement.`, {
        position: "top-right",
        autoClose: 3000,

      });
      return;
    }
    if (content?.pays_codes?.length > 0 && !content.pays_codes.includes(userCountryCode)) {
      toast.error(`Désolé, ce film n'est pas disponible dans votre pays.`, {
        position: "top-right",
        autoClose: 3000,

      });
      // alert("Désolé, ce film n'est pas disponible dans votre pays.");
      return;
    }
    if (content.isLiked) {
      // If already favorited, remove it
      try {
        const response = await axiosClient.delete(`favorites/delete/${profileId}/${content.id}/`);
        if (response.status === 204) {
          setSimilarMovies(prevData => {
            return prevData.map(val => {
              if (val.id === content?.id) {
                return {
                  ...val,
                  isLiked: false
                };
              }
              return val;
            });
          });

          setMoviePopupInfo({ ...moviePopupInfo, isLiked: false });
        }
        toast.error(`${title} a été retiré de vos favoris.`, {
          position: "top-right",
          autoClose: 3000,

        });
      } catch (error) {
        // console.error('Error removing from favorites', error);
      }
    } else {
      // If not favorited, add it
      try {
        const response = await axiosClient.post('favorites/create/', {
          profile: profileId,
          content: content.id,
        });
        if (response.status === 201) {
          setSimilarMovies(prevData => {
            return prevData.map(val => {
              if (val.id === content?.id) {
                return {
                  ...val,
                  isLiked: true
                };
              }
              return val;
            });
          });
          setMoviePopupInfo({ ...moviePopupInfo, isLiked: true });
        }
        toast.success(`${title} a été ajouté à vos favoris.`, {
          position: "top-right",
          autoClose: 3000,

        });
      } catch (error) {
        // console.error('Error adding to favorites', error);
      }
    }
  };

  const handleMovieClick = (obj) => {
    if (!userCountryCode) {
      // alert("Error: Impossible de déterminer votre emplacement.");
      toast.error(`Impossible de déterminer votre emplacement.`, {
        position: "top-right",
        autoClose: 3000,

      });
      return;
    }
    if (obj.pays_codes.length > 0 && !obj.pays_codes.includes(userCountryCode)) {
      toast.error(`Désolé, ce film n'est pas disponible dans votre pays.`, {
        position: "top-right",
        autoClose: 3000,

      });
      // alert("Désolé, ce film n'est pas disponible dans votre pays.");
      return;
    }
    handleMoviePopup(obj);
  };

  const handleMoviePopup = (movieInfo) => {
    if (shouldPop) {
      setMoviePopupInfo(movieInfo);
      setShowModal(true);

    }
  };
  const fetchMovieDetails = async (id) => {
    try {
      const response = await axiosClient.get(`/movies/${id}/?profile_id=${profileId}`);

      setMovieDetails(response.data);

      // const recommendationsResponse = await fetch(
      //   `${baseUrl}/movie/${id}/recommendations?api_key=${API_KEY}&language=en-US&page=1`
      // );
      // const recommendationsData = await recommendationsResponse.json();
      // setSimilarMovies(recommendationsData.results);
    } catch (error) {
      // console.error("Error fetching movie details:", error);
    }
  };
  const fetchSimilarContent = async (id) => {
    try {
      const response = await axiosClient.get(`/content/categories/?content_id=${id}&page_size=${20}&page=1&profile_id=${profileId}`);

      setSimilarMovies(response.data.results);

    } catch (error) {
      // console.error("Error fetching recommendations:", error);
    }
  };


  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);
  useEffect(() => {


    fetchMovieDetails(decryptId(id));
    fetchSimilarContent(decryptId(id))
  }, [id, API_KEY, urlId]);

  const modalRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        setShowModal(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [setShowModal]);
  return (
    <div>
      <Navbar playPage></Navbar>
      <ToastContainer />
      {/* {PopupMessage} */}



      {movieDetails?.id ? (
        <>
          {/* Movie details Section  */}
          <section
            style={{
              backgroundImage: `linear-gradient(0deg, rgba(18, 18, 18, 0.91) 0%, rgb(0 0 0 / 64%) 60%, rgba(83, 102, 141, 0) 100%), url(${screenWidth < 700 ? movieDetails.poster : movieDetails.image})`,
            }}
            className="bg-cover bg-center h-auto  py-24 object-contain flex flex-col p-5 min-h-[45rem] sm:p-14 lg:flex-row lg:items-center lg:justify-center lg:gap-8 "
          >
            <div className="flex flex-col justify-center lg:w-[50%] h-full ">
              <h1 className="text-white font-bold text-4xl md:text-5xl mb-2">
                {movieDetails?.title}
              </h1>

              <p className="text-neutral-400 mt-3 text-lg">{movieDetails?.description}</p>
              <div className=" w-full h-[0.1rem] my-5"></div>

              <div className="flex gap-3 flex-col sm:flex-row justify-between items-center">
                {/* Left Content */}
                <div className="grid">
                  <h1 className="text-orange-400">
                    Sorti le :{" "}
                    <a className="text-white ml-1">{movieDetails.releaseDate.split("-")[0]}</a>
                  </h1>
                  {movieDetails?.language &&
                    <h1 className="text-orange-400">
                      Langue :{" "}
                      <a className="text-white ml-1">{movieDetails.language}</a>
                    </h1>
                  }
                  {movieDetails?.origin_country &&
                    <h1 className="text-orange-400">
                      Pays d'origine :{" "}
                      <a className="text-white ml-1">{movieDetails.origin_country}</a>
                    </h1>
                  }
                  {movieDetails?.category_names?.length > 0 &&

                    <h1 className="text-orange-400">
                      Genres :{" "}
                      <a className="text-white ml-1">{movieDetails.category_names?.slice(0, 3).join(", ")}</a>
                    </h1>}

                  {movieDetails?.actors?.length > 0 &&

                    <h1 className="text-orange-400">
                      Acteurs principaux :{" "}
                      <a className="text-white ml-1">{movieDetails.actors?.join(", ")}</a>
                    </h1>
                  }
                  {movieDetails?.director_name &&

                    <h1 className="text-orange-400">
                      Réalisation :{" "}
                      <a className="text-white ml-1">{movieDetails.director_name}</a>
                    </h1>
                  }
                </div>

                {/* Button on the Right */}
                <button
                  onClick={() => playVideo(movieDetails.id, "movie")}
                  className="bg-teal-400 hover:bg-orange-400 transition duration-500 ease-in-out shadow-2xl flex items-center mb-3 mr-3 text-base sm:text-xl font-semibold text-white py-2 sm:py-2 px-5 lg:px-10 rounded-md"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="w-6 h-6 mr-2 "
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M5.25 5.653c0-.856.917-1.398 1.667-.986l11.54 6.348a1.125 1.125 0 010 1.971l-11.54 6.347a1.125 1.125 0 01-1.667-.985V5.653z"
                    />
                  </svg>
                  {(Object.keys(movieDetails?.watchHistory).length > 0 && !movieDetails?.watchHistory?.isFinished) ? "Continuer" : "Regarder"}
                </button>
              </div>


            </div>
            {/* <div className="mt-12 h-[31vh] sm:h-[42vh] md:h-[45vh] lg:h-[55vh] lg:mt-0 xl:h-[98vh]">
        <video
          poster={movieDetails?.image}
          autoPlay
          className=" w-full h-full  -z-10 object-cover"
          muted
          style={{ height: "inherit" }}
          src={movieDetails?.trailerUrl}
          controls
        ></video>
       
      </div> */}
            <div className="lg:w-[50%] h-full  flex items-center justify-center mt-5 lg:mt-0 ">
              {/* <img
                src={
                  movieDetails.image
                }
                className="w-[100%] object-cover h-full rounded-lg md:w-[45rem] md:ml-5 lg:ml-0"
              /> */}
              <video
                poster={movieDetails?.image}
                autoPlay
                controlsList="nodownload"
                className="w-full h-full object-cover  rounded-lg md:w-[50rem] md:ml-5 lg:ml-0"
                muted
                style={{ height: "inherit" }}
                src={movieDetails?.excerptUrl}
                controls={movieDetails?.excerptUrl ? true : false}
              ></video>
            </div>

          </section>

          {/* Similar movies section */}
          {similarMovies.length !== 0 && (
            <section>
              <div className="flex flex-wrap justify-center ">
                <div className="p-4 sm:p-14">
                  <h1 className="text-white text-3xl font-semibold my-10 border-l-4 border-orange-400 pl-3">
                    Vous aimerez aussi
                  </h1>
                  <div className="grid grid-cols-2 gap-4 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4">
                    {similarMovies &&
                      similarMovies.map((similarMovie, index) => {
                        return (
                          <div
                            onClick={() => handleMovieClick(similarMovie)}
                            onMouseEnter={() => setHoveredCardIndex(index)}
                            onMouseLeave={() => setHoveredCardIndex(null)}
                            key={similarMovie.id} className="cursor-pointer max-w-sm bg-black/20 shadow mb-4 hover:scale-105  group transition-all duration-500 overflow-hidden rounded-xl">
                            {hoveredCardIndex === index ? (
                              <video
                                className="h-[180px] w-full object-cover cursor-pointer"

                                src={similarMovie.trailerUrl}
                                poster={similarMovie.image}
                                onPause={() => setIsHoveredCard(false)}
                                autoPlay
                                muted
                                loop
                              />
                            ) : (
                              <img
                                src={screenWidth < 500 ? similarMovie?.poster : similarMovie?.image}
                                alt=""
                                className={`${screenWidth < 500 ? "h-[210px] w-full object-fill cursor-pointer" : "h-[150px] lg:h-[180px] w-full object-fill cursor-pointer"}`}
                                onClick={() => handleMovieClick(similarMovie)}
                              />)}
                            <div className="p-2">
                              <h5 className="mt-1 mb-2 text-xl sm:text-2xl font-bold tracking-tight text-white dark:text-white">
                                {similarMovie.title}
                              </h5>
                              <div className="flex justify-between items-center text-white mb-1">
                                <div className="flex items-center">
                                  <div className="flex sm:flex-col">

                                    <h1 className="text-xs lg:text-base ml-2 sm:ml-0">
                                      {similarMovie.releaseDate.split("-")[0]}
                                    </h1>
                                  </div>
                                  {/* <h1 className="hidden sm:grid py-1 px-2 border-2 border-gray-800 rounded-md ml-2">
                                    HD
                                  </h1> */}
                                </div>
                                <div
                                  onClick={(e) => {
                                    e.stopPropagation()
                                    handleFavoriteClick(similarMovie, similarMovie.title)
                                  }}
                                  onMouseEnter={() => setshouldPop(false)}
                                  onMouseLeave={() => setshouldPop(true)}
                                  className="cursor-pointer text-white w-9 h-9 border-[2px] rounded-full p-2 mr-1 backdrop-blur-[1px] shadow-md ease-linear transition-all duration-150 hover:text-black hover:bg-white"
                                >
                                  {similarMovie.isLiked ? (
                                    // Filled heart icon (Favorite)
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      fill="white"
                                      viewBox="0 0 24 24"
                                      strokeWidth={1.5}
                                      stroke="currentColor"
                                    >
                                      <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
                                      />
                                    </svg>
                                  ) : (
                                    // Empty heart icon (Not Favorite)
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      fill="none"
                                      viewBox="0 0 24 24"
                                      strokeWidth={1.5}
                                      stroke="currentColor"
                                    >
                                      <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
                                      />
                                    </svg>
                                  )}
                                </div>
                              </div>
                              <p className="mb-3 font-normal text-stone-400 line-clamp-3 text-xs sm:text-base">
                                {similarMovie.overview}
                              </p>
                            </div>
                          </div>
                        );
                      })}
                  </div>
                </div>
              </div>
            </section>
          )}
        </>
      ) : (
        <>
          <div className="px-4 lg:px-10 xl:px-12 animate-pulse">
            <div className="w-72 mt-4 sm:ml-0 sm:w-96 py-5 mb-7 xl:py-7 xl:w-45rem bg-neutral-900 rounded-md"></div>
            <div className="w-full py-1 mb-3 xl:py-2 bg-neutral-900 rounded-md"></div>
            <div className="w-full py-1 mb-3 xl:py-2 bg-neutral-900 rounded-md"></div>
            <div className="w-full py-1 mb-3 xl:py-2 bg-neutral-900 rounded-md"></div>
            <div className="w-full py-1 mb-8 xl:py-2 bg-neutral-900 rounded-md"></div>
          </div>
        </>
      )}
      <AnimatePresence>
        {showModal && (
          moviePopupInfo.type === "series" ? <>
            <SeriePopup
              modalRef={modalRef}
              popupInfo={moviePopupInfo}
              playSerie={playSerie}
              playMovie={playMovie}
              handleFavoriteClick={handleFavoriteClick}
              setShowModal={setShowModal}
            />
            <div className="opacity-50 fixed inset-0 z-40 bg-gray-800"></div>
          </> :
            <>
              <ContentPopup
                modalRef={modalRef}
                popupInfo={moviePopupInfo}
                playSerie={playSerie}
                playMovie={playMovie}
                handleFavoriteClick={handleFavoriteClick}
                setShowModal={setShowModal}
              />
              <div className="opacity-50 fixed inset-0 z-40 bg-gray-800"></div>
            </>
        )}
      </AnimatePresence>

      <Footer></Footer>
    </div>
  );
}

export default Play;
